import { VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { ScrollingList } from '~/components/shared/ScrollingList'
import CallLogEntry from '~/pages/CallAnalytics/CallLogs/CallLogEntry'

import { CallLog } from '@mangovoice/types'

interface CallLogsListProps {
  logEntries: CallLog[]
  onCallLogSelected: (entry: CallLog) => void
}

export const CallLogsList = ({
  logEntries,
  onCallLogSelected,
}: CallLogsListProps) => {
  const [selectedCallLogId, setSelectedCallLogId] = useState(-1)

  const handleOnCallLogSelected = (entry: CallLog) => {
    setSelectedCallLogId(entry.id)
    onCallLogSelected(entry)
  }

  return (
    <VStack display="flex" height="100%" alignSelf="stretch" gap="2px">
      <ScrollingList
        display="flex"
        flex="1"
        width="100%"
        height="70%"
        bg="bg.subtle"
        px="0.25rem"
        py="0.75rem"
        showLoaderFooter={false}
        scrollbarOptions={{ showOnHoverOnly: true }}
        itemData={logEntries}
        onBuildItemContent={(_, logEntry) => {
          return (
            <CallLogEntry
              call={logEntry}
              selectedCallId={selectedCallLogId}
              onCallLogSelected={handleOnCallLogSelected}
            />
          )
        }}
      />
    </VStack>
  )
}
